var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg__link aui-inline"},[(_vm.url)?_c('a',{staticClass:"link no-underline",attrs:{"href":_vm.url,"target":"_blank"}},[_vm._t("default")],2):_c('span',[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }